/**
 * Id de seção do manual a partir do texto do heading: sem acento, minúsculo, não-alfanumérico
 * vira "-". `headingSlug('Segmentos de valor (RFM)') === 'segmentos-de-valor-rfm'`.
 * Usado pelo MarkdownRenderer (id dos headings) e por quem linka direto para uma seção
 * (ManualLinkButton `section`).
 */
export const headingSlug = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
